import React, { useState } from 'react';
import PlaystoreDetails from './PlaystoreDetails';
import './Intro.css';

function Intro() {
  const handleGetStarted = () => {
    window.open("https://play.google.com/store/apps/details?id=com.nosc.gpscamera")
  };

  return (
    <div className="intro-container">
      {/* Background with subtle gradient */}
      <div className="background-blobs">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      {/* Header */}
      <header className="intro-header">
        <div className="logo-container">
          <div className="app-logo">
            {/* <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 20 20 8Z" fill="url(#gradient)"/>
              <path d="M26 15C26 16.6569 24.6569 18 23 18C21.3431 18 20 16.6569 20 15C20 13.3431 21.3431 12 23 12C24.6569 12 26 13.3431 26 15Z" fill="white"/>
              <defs>
                <linearGradient id="gradient" x1="8" y1="8" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#667eea"/>
                  <stop offset="1" stopColor="#764ba2"/>
                </linearGradient>
              </defs>
            </svg> */}
          </div>
          <h1 className="app-name">GPS Camera: Geolocation</h1>
          <p className="app-tagline">Capture moments with location</p>
          <p className='app-description'>Every photo tells a story. Now every story knows where it began. Automatically stamp location details on your photos as you capture life's precious moments.</p>
        </div>
      </header>
        <PlaystoreDetails/>
      {/* Main Content */}
      <main className="intro-content">
        {/* Feature Cards with Glass Morphism */}
        <div className="features-grid">
          {/* Card 1: Camera Feature */}
          <div className="glass-card feature-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="card-title">High-Quality Capture</h3>
            <p className="card-description">
              Take stunning photos with our advanced camera system
            </p>
          </div>

          {/* Card 2: Location Feature */}
          <div className="glass-card feature-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="card-title">Auto Location Stamp</h3>
            <p className="card-description">
              Automatically stamp GPS coordinates on every photo you take
            </p>
          </div>

          {/* Card 3: Organization Feature */}
          <div className="glass-card feature-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 17V11" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 14H15" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="card-title">Smart Organization</h3>
            <p className="card-description">
              Automatically organize photos by location and date
            </p>
          </div>
        </div>

        {/* App Preview */}
        <div className="app-preview glass-card">
          <div className="preview-header">
            <h3 className="preview-title">How It Works</h3>
          </div>
          <div className="preview-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Take Photo</h4>
                <p>Capture your moment with the camera</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Auto Location</h4>
                <p>GPS coordinates are automatically added</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Save & Share</h4>
                <p>Store or share your geotagged photos</p>
              </div>
            </div>
          </div>
        </div>

        {/* Permissions Note */}
        <div className="permissions-note glass-card">
          <div className="permissions-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16V12" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8H12.01" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <p>This app needs camera and location permissions to function properly</p>
        </div>
      </main>

      {/* Footer with CTA Button */}
      <footer className="intro-footer">
        <button className="get-started-btn" onClick={handleGetStarted}>
          <span>Download App</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <div className="footer-links">
          <button className="link-btn">Privacy Policy</button>
          <span className="divider">•</span>
          <button className="link-btn">Terms of Service</button>
          <span className="divider">•</span>
          <button className="link-btn">Contact</button>
        </div>
      </footer>
    </div>
  );
}

export default Intro;